import * as React from 'react'
import type {SVGProps} from 'react'
const SvgCheckBoxSelected = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        width={15}
        height={15}
        viewBox="2.5 2.5 15 15"
        {...props}
    >
        <path
            fill="#178938"
            d="m8.375 10.959 5.38-5.459L15.5 7.27 8.375 14.5 4.5 10.564l1.746-1.769z"
        />
    </svg>
)
export default SvgCheckBoxSelected
